//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { ArrowBackIcon, QuestionIcon, WarningIcon } from "@chakra-ui/icons";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  Collapse,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Icon,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { observer } from "mobx-react-lite";
import React from "react";
import { object, string } from "yup";
import { formatPrice } from "../../../utils/functions";
import { SingleFormButton } from "../FormButtons";
import Pluralize from "pluralize";

const setNumberOfHours = (hours) => {
  if (hours === 1) return 1.2;
  if (hours === 1.5) return 1.6;
  if (hours === 4) return 3.7;
  if (hours === 5) return 4.5;
  if (hours === 6) return 5;
  return hours;
};

function getAdjustedRates(hourlyRate) {
  let adjustedRates = [];
  for (let hours = 1; hours < 7; hours++) {
    let priceObj = {
      hoursBooked: hours,
      hourlyRate: Math.round((hourlyRate * setNumberOfHours(hours)) / hours),
    };
    adjustedRates.push(priceObj);
  }

  return adjustedRates;
}

const commonProps = ({ name }, { touched, errors }) => ({
  label: "Hourly rate per student",
  placeholder: "No price set",
  isInvalid: Boolean(touched[name] && errors[name]),
  errorMessage: errors[name],
});

export const HourlyRate: React.FC<{
  initialValues: { hourlyRate: string };
  onBackClick: () => void;
  onEditPrice: (values: any) => void;
  howPriceWorksClick?: (step: any) => void;
  priceSuggestion?: {
    minimum: string | number;
    maximum: string | number;
    recommended: string | number;
  };
  earningPercentage?: number;
  isLoading?: boolean;
  currency: string;
  subject?: string;
  onSubmit: (values: any) => Promise<any>;
}> = observer(
  ({
    onBackClick,
    initialValues,
    priceSuggestion,
    earningPercentage,
    howPriceWorksClick,
    currency,
    subject,
    onEditPrice,
    isLoading,
    onSubmit,
  }) => {
    const [showBreakdown, setShowBreakdown] = React.useState(false);
    const tuteriaPercentage = 100 - earningPercentage;

    const isGoodPrice = (price) => {
      if (!!price) {
        const isMin = Number(priceSuggestion.minimum) <= Number(price);
        const isMax = Number(priceSuggestion.maximum) >= Number(price);
        if (isMin && isMax) return true;
        return false;
      }
      return false;
    };

    const validationSchema = object().shape({
      hourlyRate: string().required(
        "Please set pricing using the button above",
      ),
    });
    return (
      <Box className="set-hourly-price">
        <Button
          mb={6}
          onClick={onBackClick}
          leftIcon={<ArrowBackIcon />}
          variant="link"
          colorScheme="blue"
        >
          Back
        </Button>

        <Stack pb={6}>
          <Text fontSize="3xl" lineHeight="shorter" fontWeight="bold" as="h1">
            Hourly rate
          </Text>
          <Text mt={1} color="gray.700">
            This is the price that clients will pay for 1 hour of {subject}{" "}
            lessons
          </Text>
        </Stack>

        <Formik
          initialValues={{
            hourlyRate: initialValues.hourlyRate,
          }}
          onSubmit={onSubmit}
          key={initialValues?.hourlyRate}
          validationSchema={validationSchema}
        >
          {({ handleSubmit, values }) => (
            <Form>
              <Stack mb={8} pb={20}>
                <Field
                  name="hourlyRate"
                  render={({ field, form }) => {
                    const tutorEarning =
                      Number(values.hourlyRate) * (earningPercentage / 100);
                    const tuteriaEarning =
                      Number(values.hourlyRate) * (tuteriaPercentage / 100);

                    return (
                      <Stack spacing="6">
                        <FormControl
                          isInvalid={commonProps(field, form).isInvalid}
                        >
                          <FormLabel>
                            {commonProps(field, form).label}
                          </FormLabel>
                          <Box
                            borderWidth="2xs"
                            borderColor="neutral.500"
                            rounded="md"
                            overflow="hidden"
                          >
                            <Flex>
                              <Input
                                isDisabled
                                height="3.5rem"
                                size="lg"
                                flex="4"
                                opacity="1"
                                rounded="none"
                                border="none"
                                fontSize="xl"
                                fontWeight={field.value ? "medium" : "normal"}
                                borderColor="neutral.700"
                                {...field}
                                {...commonProps(field, form)}
                                name={field.name}
                                value={formatPrice(field.value)}
                                onChange={({ target }) => {
                                  form.setFieldValue(field.name, target.value);
                                }}
                              />

                              <Button
                                flex={1}
                                bg="white"
                                shadow="none"
                                color="blue.500"
                                borderLeftWidth="2xs"
                                borderColor="neutral.500"
                                roundedLeft="none"
                                roundedBottomRight="none"
                                height="3.5rem"
                                onClick={() => onEditPrice(values)}
                              >
                                {field.value ? "Edit" : "Set"}
                                <br />
                                Price
                              </Button>
                            </Flex>

                            {values.hourlyRate && (
                              <Stack
                                borderTopWidth="2xs"
                                borderColor="neutral.500"
                                spacing={3}
                                px={4}
                                py={3}
                                bg="neutral.200"
                              >
                                {values.hourlyRate && (
                                  <HStack
                                    justify="space-between"
                                    align="center"
                                  >
                                    <Box>
                                      <Text fontWeight="light" fontSize="xs">
                                        What this means
                                      </Text>
                                      <Text
                                        fontWeight={
                                          showBreakdown ? "semibold" : "normal"
                                        }
                                      >
                                        You'll earn {formatPrice(tutorEarning)}{" "}
                                        /hr
                                      </Text>
                                    </Box>
                                    <Icon
                                      cursor="pointer"
                                      as={QuestionIcon}
                                      fontSize="xl"
                                      onClick={() =>
                                        setShowBreakdown(!showBreakdown)
                                      }
                                    />
                                  </HStack>
                                )}

                                <Collapse in={showBreakdown}>
                                  <Box pb={6}>
                                    <Box pb={4}>
                                      When you get bookings, Tuteria's fee is
                                      deducted from your price as shown:
                                    </Box>

                                    <Stack mb={6}>
                                      <Flex>
                                        <Text flex={1}>Client pays:</Text>
                                        <Text flex={1}>
                                          {formatPrice(values.hourlyRate)} /hr
                                        </Text>
                                      </Flex>

                                      <Flex>
                                        <Text flex={1}>Tuteria deducts:</Text>
                                        <Text flex={1}>
                                          {formatPrice(tuteriaEarning)} /hr (
                                          {tuteriaPercentage}%)
                                        </Text>
                                      </Flex>

                                      <Flex>
                                        <Text flex={1}>You are paid:</Text>
                                        <Text flex={1}>
                                          {formatPrice(tutorEarning)} /hr (
                                          {earningPercentage}%)
                                        </Text>
                                      </Flex>
                                    </Stack>

                                    <Text>
                                      This helps us cover marketing and
                                      operational costs to manage lessons and
                                      get you more clients.
                                    </Text>
                                  </Box>

                                  <Box pb={4}>
                                    <Text pb={2} fontWeight="semibold">
                                      Adjusted hourly rates for lessons
                                    </Text>
                                    <Text pb={2}>
                                      When you are booked for less than 2 hours
                                      per lesson, we push up your rate by
                                      10-20%, as well as apply a small discount
                                      when you're booked for 4 or more hours as
                                      shown:
                                    </Text>

                                    <Stack mt={3} spacing={3}>
                                      <Flex fontWeight="medium">
                                        <Text flex={2}>Booked for</Text>
                                        <Text flex={2}>Charge rate</Text>
                                      </Flex>

                                      {getAdjustedRates(values.hourlyRate).map(
                                        ({ hoursBooked, hourlyRate }) => (
                                          <Flex key={hoursBooked}>
                                            <Text flex={2}>
                                              {Pluralize(
                                                "hour",
                                                hoursBooked,
                                                true,
                                              )}
                                            </Text>

                                            <Text flex={2}>
                                              {formatPrice(hourlyRate)} /hr
                                            </Text>
                                          </Flex>
                                        ),
                                      )}
                                    </Stack>
                                  </Box>

                                  <Button
                                    my={5}
                                    variant="link"
                                    colorScheme="blue"
                                    onClick={() =>
                                      howPriceWorksClick("View-pricing")
                                    }
                                  >
                                    Learn how pricing works
                                  </Button>
                                </Collapse>
                              </Stack>
                            )}
                          </Box>

                          <FormErrorMessage>
                            {commonProps(field, form).errorMessage}
                          </FormErrorMessage>
                        </FormControl>

                        {values.hourlyRate &&
                          !isGoodPrice(values.hourlyRate) && (
                            <Alert status="warning" p={[5, 6]} rounded="md">
                              <Box flex="1">
                                <Icon
                                  as={WarningIcon}
                                  fontSize="2xl"
                                  mb="16px"
                                  color="orange.500"
                                />
                                <AlertTitle>
                                  You may get fewer bookings
                                </AlertTitle>
                                <AlertDescription display="block">
                                  <Stack spacing={3}>
                                    <Text>
                                      Consider charging between{" "}
                                      {formatPrice(priceSuggestion.minimum)} -{" "}
                                      {formatPrice(priceSuggestion.maximum)} to
                                      increase your chances of getting more
                                      bookings
                                    </Text>

                                    <HStack
                                      justify="space-between"
                                      align="center"
                                    >
                                      <Box>
                                        <Text fontWeight="light" fontSize="xs">
                                          Suggestion
                                        </Text>
                                        <Text
                                          lineHeight="shorter"
                                          fontWeight="medium"
                                          fontSize="lg"
                                        >
                                          {formatPrice(
                                            priceSuggestion.recommended,
                                          )}{" "}
                                          /hr
                                        </Text>
                                      </Box>

                                      <Button
                                        bg="black"
                                        color="white"
                                        rounded="md"
                                        size="sm"
                                        onClick={() => {
                                          setShowBreakdown(false);
                                          form.setFieldValue(
                                            field.name,
                                            priceSuggestion.recommended,
                                          );
                                        }}
                                      >
                                        Use this
                                      </Button>
                                    </HStack>
                                  </Stack>
                                </AlertDescription>
                              </Box>
                            </Alert>
                          )}

                        {values.hourlyRate &&
                          isGoodPrice(values.hourlyRate) && (
                            <Alert status="success" p={[5, 6]} rounded="md">
                              <AlertIcon />
                              <AlertTitle>Price looks good</AlertTitle>
                            </Alert>
                          )}
                      </Stack>
                    );
                  }}
                />
              </Stack>

              <SingleFormButton
                nextText="Save pricing"
                isLoading={isLoading}
                onNextClick={handleSubmit}
              />
            </Form>
          )}
        </Formik>
      </Box>
    );
  },
);
